import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "disabled", "external", "extraJSONData", "failed", "href", "immediate", "loading", "onClick", "responsive", "size", "trackableKey", "type", "use", "data-test-id"];
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackableButton = _ref => {
  let {
      children,
      disabled,
      external,
      extraJSONData = {},
      failed,
      href,
      immediate,
      loading,
      onClick,
      responsive,
      size,
      trackableKey,
      type,
      use,
      'data-test-id': dataTestId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const trackEvent = useTrackEvent();
  const {
    tokenProps
  } = filterTokenProps(rest);
  const hasSpaceStyleProps = Object.keys(tokenProps).length > 0;

  // If a button click makes a route change that is not
  // external (in a new tab), click tracking could be
  // lost, so use Beacons to improve capture.
  const shouldUseImmediateTracker = !external && !!href || immediate;
  const onTrackedEvent = e => {
    trackEvent(trackableKey, extraJSONData, shouldUseImmediateTracker);
    onClick(e);
  };

  // Use LoadingButton if loading prop is explicitly set true or false,
  // else assume there is no loading functionality needed and use Button
  const useLoadingButton = typeof loading === 'boolean';

  // TODO: this component is rendered inside UIDropdown's which doesn't have
  // styles "in menu" styles targeted at foundations components so they end
  // up center aligned. maintaining usage of UIButtons until foundations
  // Dropdown component is ready for prime time and menus and buttons can be
  // migrated at the same time.
  if (useLoadingButton && !hasSpaceStyleProps) {
    return /*#__PURE__*/_jsx(UILoadingButton, {
      disabled: disabled,
      failed: failed,
      onClick: onTrackedEvent,
      responsive: responsive,
      size: size,
      type: type,
      use: use,
      "data-test-id": dataTestId,
      href: href,
      children: children
    });
  }
  if (useLoadingButton && hasSpaceStyleProps) {
    return /*#__PURE__*/_jsx(LoadingButton, Object.assign({}, tokenProps, {
      disabled: disabled,
      failed: failed,
      onClick: onTrackedEvent,
      responsive: responsive,
      size: size,
      type: type,
      use: use,
      "data-test-id": dataTestId,
      href: href,
      children: children
    }));
  }
  if (!useLoadingButton && !hasSpaceStyleProps) {
    return /*#__PURE__*/_jsx(UIButton, {
      disabled: disabled,
      onClick: onTrackedEvent,
      responsive: responsive,
      size: size,
      type: type,
      use: use,
      href: href,
      "data-test-id": dataTestId,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(Button, Object.assign({}, tokenProps, {
    disabled: disabled,
    onClick: onTrackedEvent,
    responsive: responsive,
    size: size,
    type: type,
    use: use,
    href: href,
    "data-test-id": dataTestId,
    children: children
  }));
};
export default TrackableButton;